import axios from 'axios';

class WordPressProvider {
  constructor() {
    this.TEMPBASEURL = 'https://apiwebeureciclo.giro.org.br';
    this.PATHTOPAGES = 'wp-json/wp/v2/pages';
  }

  async getPageBySlug(pageSlug) {
    return axios.get(
      `${this.TEMPBASEURL}/${this.PATHTOPAGES}/?slug=${pageSlug}`,
    );
  }
}
export default new WordPressProvider();
